<template lang="pug">
 quillEditor( :disabled="readonly", v-model='text', :options='editorOption',@change="onEditorChange" :style="styleProp")
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import editor_option from "@/utils/editorOption.js";
export default {
  name: "quillCom",
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    fahertext: {
      type: String,
      default: ""
    },
    styleProp: {
      type: Object,
      default() {
        return {
          width: "250px",
          height: "250px",
          marginBottom: "10px"
        };
      }
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      editorOption: editor_option.editorOption,
      text: ""
    };
  },
  methods: {
    onEditorChange(val) {
      this.$emit("update:fathertext", val.html);
    }
  },
  created() {
    this.text = this.fahertext;
  },
  watch: {
    fahertext(val) {
      this.text = val;
    }
  }
};
</script>
<style lang="less">
</style>